import React, { useState } from 'react'
import URL from '../Account/_Components/URL'
import TutorialModal from './Components/TutorialModal'
import StaffTutorials from './Components/StaffTutorials'
import LicensedTutorials from './Components/LicensedTutorials'
import { Container, Image, Row, Col } from 'react-bootstrap'

export default function WelcomePage({ currentUser, clientDetails }) {
  const [currentTutorial, setCurrentTutorial] = useState('')
  const [showTutorialModal, setShowTutorialModal] = useState(false)

  const handleShowTutorial = (tutorial) => {
    setCurrentTutorial(tutorial)
    setShowTutorialModal(true)
  }
  
  const handleHideTutorial = () => {
    setShowTutorialModal(false)
  }

  return (
    <Container>
      <TutorialModal 
        show={showTutorialModal} 
        tutorial={currentTutorial} 
        handleClose={handleHideTutorial}
      />
      <Row className='my-4'>
        <Col>
          <h5>Welcome, { currentUser.FirstName } {currentUser.LastName }</h5>
          <p>Get familiar with AxS Health with the following tutorials.</p>
        </Col>
        <Col>
          <h5 className="text-right">{ clientDetails.name }</h5>
          {/* <Image src={LugoniaLogo}  fluid /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <h6 className='font-weight-light'>Log In Details</h6>
            </Col>
          </Row>
          <Row className='my-4'>
            <Col className='pr-5'>
              <p>Bookmark this page for quick and easy login!</p>
              <URL urlString={`https://${clientDetails.accountDomain}`} />
            </Col>
          </Row>
          <Row>
            <Col>
              <small className='text-muted'>
                <p className='mb-2'>Add this page to your bookmarks by pressing the following keys:</p>
                <p className='font-weight-bold'>Command/Cmd/CTRL + D</p>
              </small>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col className='lead'>
              <small>
                Your login username is: <br />
                <p className='text-muted'>{ currentUser.Username }</p>
              </small>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className='mb-2'>
            <Col>
              <h6 className='font-weight-light'>Tutorials</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              { currentUser.UserType.Name === 'Staff' ? 
                <StaffTutorials handleShowTutorial={handleShowTutorial} /> : 
                <LicensedTutorials handleShowTutorial={handleShowTutorial} /> 
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}
